export default __webpack_public_path__ + "static/media/icon-review.7e873e11.svg";